import { Component, inject } from '@angular/core';

import { DownloadService } from './download.service';
import { environment } from '../environments/environment';
import { OperationFeedbackItemData } from './xfer/components/operation-feedback/operation-feedback.interfaces';
import { ExhaustiveModeService } from './exhaustive-mode.service';
import { IconService } from './icon.service';
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  private downloadService = inject(DownloadService);
  private authService = inject(AuthService);
  private iconService = inject(IconService);

  title = 'frontend';
  protected exhaustiveModeService = inject(ExhaustiveModeService);
  protected configService = inject(ConfigService);
  protected downloads$ = this.downloadService.downloads$;

  constructor() {
    document.title = environment.title;
    if (environment.favicon) {
      document
        .getElementById('favicon')
        ?.setAttribute('href', environment.favicon);
    }
  }

  refreshActivityTimer(): void {
    this.authService.resetSessionTimeout();
  }

  protected async onCancelDownloads(): Promise<void> {
    await this.downloadService.cancelDownloads();
  }

  protected async onRetryDownload(
    payload: OperationFeedbackItemData,
  ): Promise<void> {
    await this.downloadService.retryDownload(payload);
  }

  protected async onCancelDownload(
    item: OperationFeedbackItemData,
  ): Promise<void> {
    await this.downloadService.cancelDownload(item.payload.id);
  }
}
